export default __webpack_public_path__ + "static/media/ClientLogInPopUp.87f762f9.png";